export const props = Object.freeze({
  /**
   * URL of the image to load. When the load fails, the component swaps to a placeholder SVG.
   *
   * @type {String}
   */
  src: {
    type: String,
    required: true,
  },
  /**
   * Alt text rendered on the <img> element and on the placeholder's <title> for accessibility.
   *
   * @type {String}
   * @default ""
   */
  alt: {
    type: String,
    default: "",
  },
  /**
   * Background fill colour of the placeholder SVG. Overrides --sp-comp-img-placeholder-background.
   *
   * @type {String}
   * @default "var(--sp-ref-palette-outline-variant, #ddd)"
   */
  placeholderbackground: {
    type: String,
    default: "var(--sp-ref-palette-outline-variant, #ddd)",
  },
  /**
   * Foreground fill colour of the placeholder SVG (the camera glyph). Overrides
   * --sp-comp-img-placeholder-color.
   *
   * @type {String}
   * @default "var(--sp-ref-palette-outline, #333)"
   */
  placeholdercolor: {
    type: String,
    default: "var(--sp-ref-palette-outline, #333)",
  },
});
